<template>
    <div class="right" id="stasheRight">

        <div class="title reveal" id="stashe"> 
            <h1>{{ title }}</h1>
        </div>

        <div class="description reveal" id="stashe"> 
            <h3>{{ description }}</h3>
        </div>

        <div class="linkContainer reveal" id="stashe">
            <a class="line-link" href="https://apple.co/2zwRgML" target="_blank">
                {{ buttonText }}
            </a>
        </div>

    </div>

</template>


<script>


export default {
  name: 'StasheRightColumn',
  data() {
    return {
      title: 'Stashe',
      description: 'Stashe helps you to save your favorite internet gems for later, and share them with 7 or fewer best friends at lightning speed ',
        buttonText: 'Get the app'
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

$lineHeight: 2px;
$lineWidthSmall: 15%;
$animationDuration: 0.5s;
$animationCurve: all $animationDuration cubic-bezier(0.22, 0.61, 0.36, 1);

.right {
    overflow: hidden;
    text-align: right;
    max-width: 25em;
    font-family: 'Avenir';
}

h1 {
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 0.3em;
}

h3 {
    font-weight: 300;
    // padding-left: 1.75em;

}

.line-link {
    cursor: pointer;
    position: relative;
    // text-align: right;
    display: inline-block;
    padding-bottom: 0.5em;

    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: .3em;
    font-weight: 700;
    color: #BD10E0;

    transition: $animationCurve;
}

.linkContainer {
    text-align: left;
}

.line-link:before, .line-link:after {
    content: ' ';
    position: absolute;
    background: #BD10E0;
    height: $lineHeight;
    bottom: 0;

    transition: $animationCurve;
}

.line-link:before {
    width: $lineWidthSmall;
    left: 0;
    transition-delay: 0.5s;
}

.line-link:hover::before {
    width: 0%;

    transition: width 0.1ms cubic-bezier(0.22, 0.61, 0.36, 1);
    transition-delay: 0.1ms;
}

.line-link:after {
    width: 0%;
    right: 0;

}

.line-link:hover::after {
    width: 100%; 
    left: 0;
}




// a{
//   width: 50px;
//   float: left;
//     -webkit-transition: 0.5s ease;

//   &:hover{
//     text-shadow: 0px -2px 0px rgba(0,0,0,1), 0 0 5px rgba(255,255,255,0.8),0 -4px 15px rgba(255,255,255,0.5);
//   }
//   &:nth-of-type(2):hover ~ .underbar{
//     left: 50px;
//     width: 40px;
//     background: rgba(200,100,100,1);
//   }
//   cursor: pointer;
// }

// a:before {
// //   content: "";
// //   position: absolute;
// //   width: 100%;
//   height: 2px;
//   bottom: 0;
//   left: 0;
// //   background-color: #000;
//   visibility: hidden;
//   -webkit-transform: scaleX(0);
//   transform: scaleX(0);
//   -webkit-transition: all 0.3s ease-in-out 0s;
//   transition: all 0.3s ease-in-out 0s;
// }

// a:hover:before {
//   visibility: visible;
//   -webkit-transform: scaleX(1);
//   transform: scaleX(1);
// }

</style>



// WEBPACK FOOTER //
// src/components/Apps/Stashe/StasheRight.vue